/**
 * Message types and utility functions for postMessage communication between Chat iframe and parent window.
 * Following the pattern from agent-handler-link.
 */
// ============================================================================
// Message Type Constants
// ============================================================================
// Chat Iframe → Parent messages
export var AH_CHAT_OPEN_LINK_TO_PARENT = "AH_CHAT_OPEN_LINK_TO_PARENT";
export var AH_CHAT_OPEN_IN_TO_PARENT = "AH_CHAT_OPEN_IN_TO_PARENT";
export var AH_CHAT_COPY_TO_PARENT = "AH_CHAT_COPY_TO_PARENT";
export var AH_CHAT_SELECTION_CHANGE_TO_PARENT = "AH_CHAT_SELECTION_CHANGE_TO_PARENT";
export var AH_CHAT_READY = "AH_CHAT_READY";
// Parent → Chat Iframe messages
export var AH_PARENT_LINK_SUCCESS_TO_IFRAME = "AH_PARENT_LINK_SUCCESS_TO_IFRAME";
export var AH_PARENT_LINK_EXIT_TO_IFRAME = "AH_PARENT_LINK_EXIT_TO_IFRAME";
// ============================================================================
// Utility Functions
// ============================================================================
/**
 * Notify parent that Link needs to be opened for authentication
 */
export var sendOpenLinkToParent = function (linkToken, apiBaseURL) {
    window.parent.postMessage({
        messageType: AH_CHAT_OPEN_LINK_TO_PARENT,
        linkToken: linkToken,
        apiBaseURL: apiBaseURL,
    }, "*");
};
/**
 * Notify parent that "Open in..." was clicked
 */
export var sendOpenInToParent = function (ideId, toolPackId, registeredUserId) {
    window.parent.postMessage({
        messageType: AH_CHAT_OPEN_IN_TO_PARENT,
        ideId: ideId,
        toolPackId: toolPackId,
        registeredUserId: registeredUserId,
    }, "*");
};
/**
 * Ask parent to copy text to clipboard (iframe can't use Clipboard API)
 */
export var sendCopyToParent = function (text) {
    window.parent.postMessage({
        messageType: AH_CHAT_COPY_TO_PARENT,
        text: text,
    }, "*");
};
/**
 * Notify parent that Tool Pack or Registered User selection changed
 */
export var sendSelectionChangeToParent = function (toolPackId, registeredUserId) {
    window.parent.postMessage({
        messageType: AH_CHAT_SELECTION_CHANGE_TO_PARENT,
        toolPackId: toolPackId,
        registeredUserId: registeredUserId,
    }, "*");
};
/**
 * Notify parent that Chat iframe is ready
 */
export var sendChatReady = function () {
    window.parent.postMessage({
        messageType: AH_CHAT_READY,
    }, "*");
};
